import React from 'react';
import { __ } from 'i18n/index';

/**
 * The "Live now" column: the site news (services\intro\SiteNews) on top, then
 * every visible stream, clickable into the main player.
 */
export default function StreamRail({ streams, gamesById, featuredChannel, onWatch, news = [] }) {
	return (
		<aside className='stream-rail' aria-label={__('Live now')}>
			<RailNews items={news} />
			<div className='stream-rail__head'>
				<span>{__('Live now')}</span>
				{streams.length > 0 && <span className='stream-rail__count'>{streams.length}</span>}
			</div>
			{streams.length === 0
				? <p className='stream-rail__empty'>{__('No live streams for this game.')}</p>
				: (
					<ul className='stream-rail__list'>
						{streams.map((stream) => {
							const game = gamesById[stream.ladder_id];
							const isPlaying = stream.channel === featuredChannel;
							return (
								<li key={stream.channel}>
									<button
										type='button'
										className={'stream-rail__item' + (isPlaying ? ' is-playing' : '')}
										aria-label={__('Watch %s', stream.display_name)}
										aria-pressed={isPlaying}
										onClick={() => onWatch(stream.channel)}
									>
										<span className='stream-rail__thumb'>
											<img src={stream.thumbnail_url} alt='' loading='lazy' />
											<span className='stream-rail__viewers'>{stream.viewer_count.toLocaleString('en-US')}</span>
										</span>
										<span className='stream-rail__text'>
											<span className='stream-rail__name'>{stream.display_name}</span>
											{game && <span className='stream-rail__game'>{game.name}</span>}
											<span className='stream-rail__title'>{stream.title}</span>
										</span>
									</button>
								</li>
							);
						})}
					</ul>
				)}
		</aside>
	);
}

function RailNews({ items }) {
	if(items.length === 0) {
		return null;
	}
	return (
		<section className='rail-news' aria-labelledby='rail-news-heading'>
			<h2 id='rail-news-heading' className='rail-news__heading'>{__('News')}</h2>
			<ul className='rail-news__list'>
				{items.map((item) => (
					<li key={item.id} className='rail-news__item'>
						<h3 className='rail-news__title'>{item.title}</h3>
						<p className='rail-news__body'>{item.body}</p>
						<time className='rail-news__date' dateTime={item.published_on}>{item.date_label}</time>
					</li>
				))}
			</ul>
		</section>
	);
}
